<template>
  <div class="mt-2 w-full">
    <label
      class="block text-left uppercase tracking-wide text-gray-700 text-xs font-bold"
      >{{ label }}</label
    >
    <div class="mt-2 pl-2 py-2 pr-1 border border-gray-300 rounded-lg">
      <div v-if="!readonly" class="flex items-center">
        <input
          ref="input"
          class="py-2 px-3 focus:outline-none focus:shadow-outline appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
          type="text"
          autocomplete="off"
          @keypress.enter="add(newItem)"
          :placeholder="placeholder"
          v-model.trim="newItem"
        />
        <button
          class="ml-1 p-2 text-base focus:outline-none focus:shadow-outline text-gray-600 hover:text-gray-900 bg-transparent hover:bg-gray-200 rounded-full h-10 w-12 flex items-center justify-center"
          @click.prevent="add(newItem)"
        >
          <unicon name="plus-circle" />
        </button>
      </div>
      <ul class="flex flex-col items-center">
        <li
          class="pl-2 w-full bg-transparent text-gray-900 rounded flex items-center focus-within:outline-none"
          v-for="i in list"
          :key="i"
        >
          <p class="w-full text-left truncate">{{ i }}</p>
          <button
            v-if="!readonly"
            class="ml-2 p-2 h-10 w-12 flex items-center justify-center text-base focus:outline-none focus:shadow-outline text-gray-600 hover:text-gray-900 bg-transparent hover:bg-gray-200 rounded-full"
            @click="remove(i)"
          >
            <unicon name="minus-circle" />
          </button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { validateEmail, validatePhone } from '@/utils.js'
export default {
  name: 'TodoList',
  props: {
    label: {
      type: String,
      required: false,
      default() {
        return ''
      }
    },
    placeholder: {
      type: [String, Number, Boolean],
      required: false,
      default() {
        return ''
      }
    },
    list: {
      type: Array,
      required: false,
      default() {
        return []
      }
    },
    validationType: {
      type: String,
      required: false,
      default() {
        return 'email'
      }
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      newItem: null
    }
  },
  methods: {
    add(i) {
      if (!i || this.list.includes(i)) return

      console.log(this.validationType, validateEmail(i), validatePhone(i))
      if (this.validationType === 'email' && !validateEmail(i)) return
      if (this.validationType === 'phone' && !validatePhone(i)) return
      this.$emit('add', i)
      this.newItem = ''
      this.$nextTick(() => this.$refs.input.focus())
    },
    remove(i) {
      this.$refs.input.focus()
      this.$emit('remove', i)
    },
    focus(i) {
      console.log(i, this.$refs)
      this.$nextTick(() => this.$refs[i].focus())
    }
  }
}
</script>
